import React from 'react';
import { Link } from 'react-scroll';
import { headerButtons, homepage } from './data';
import { HEADER } from './assets';
import styles from './Header.module.scss';

export default function Header() {

    return (
        <div className={styles["container"]}>
            <div className={styles["logo-section"]}>
                <a href={homepage}>
                    <img src={HEADER.LOGO.default} alt="Logo" className={styles["logo"]} />
                </a>
            </div>
            <div className={styles["button-section"]}>
                {headerButtons.map((item, key) => {
                    return (
                        <>
                            <Link
                                activeClass="active"
                                to={item.id}
                                spy={true}
                                smooth={true}
                                offset={item.id === "frontPage" ? -78 : 0}
                                duration={1000}
                            >
                                <div className={styles["buttons"]}>
                                    <img src={item.label} alt="Button" />
                                </div>

                            </Link>
                            <div className={styles[`dashed${key}`]}>
                                <img src={HEADER.DASH.default} alt="Dash" />
                            </div>
                        </>
                    )
                })}
            </div>
            <div className={styles["social-section"]}></div>
        </div>
    )
}